/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Suggest_AnotherInputs */

const en_us2_community_suggest_another = /** @type {(inputs: Community_Suggest_AnotherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send another`)
};

const pt_br2_community_suggest_another = /** @type {(inputs: Community_Suggest_AnotherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar outra`)
};

const es_419_community_suggest_another = /** @type {(inputs: Community_Suggest_AnotherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar otra`)
};

const pt_pt2_community_suggest_another = /** @type {(inputs: Community_Suggest_AnotherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar outra`)
};

const fr_fr2_community_suggest_another = /** @type {(inputs: Community_Suggest_AnotherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En envoyer une autre`)
};

const de_de2_community_suggest_another = /** @type {(inputs: Community_Suggest_AnotherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch einen senden`)
};

const it_it2_community_suggest_another = /** @type {(inputs: Community_Suggest_AnotherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviane un'altra`)
};

/**
* | output |
* | --- |
* | "Send another" |
*
* @param {Community_Suggest_AnotherInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_suggest_another = /** @type {((inputs?: Community_Suggest_AnotherInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Suggest_AnotherInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_suggest_another(inputs)
	if (locale === "es-419") return es_419_community_suggest_another(inputs)
	if (locale === "pt-PT") return pt_pt2_community_suggest_another(inputs)
	if (locale === "fr-FR") return fr_fr2_community_suggest_another(inputs)
	if (locale === "de-DE") return de_de2_community_suggest_another(inputs)
	if (locale === "it-IT") return it_it2_community_suggest_another(inputs)
	return en_us2_community_suggest_another(inputs)
});
export { community_suggest_another as "community.suggest_another" }